/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import About from 'pages/About';
import Certifications from 'pages/Certifications';
import Education from 'pages/Education';
import Experience from 'pages/Experience';
import Home from 'pages/Home';
import Projects from 'pages/Projects';
import Skills from 'pages/Skills';
import { PublicRoutes } from 'types/common/Routes';

const PUBLIC_ROUTES = [
  { path: '/', component: Home },
  { path: '/about', component: About },
  { path: '/skills', component: Skills },
  { path: '/projects', component: Projects },
  { path: '/experience', component: Experience },
  { path: '/education', component: Education },
  { path: '/certifications', component: Certifications },
] satisfies PublicRoutes[];

export default PUBLIC_ROUTES;
